import React, { useEffect } from 'react';
import { Button, Switch, Drawer, Form, Input, message } from 'antd';
import {
  REQUEST_LOADING,
  SUCCESS_CREATE,
  SUCCESS_UPDATE,
} from 'constants/alerts';
import { requiredRule } from 'utils/forms/validationRules';
import { ModulesService } from 'services/ModulesService';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';

function ModulesForm({ isActive, onClose, onSuccess, initialValues }) {
  const [form] = Form.useForm();
  const isEditing = initialValues !== null;

  useEffect(() => {
    if (initialValues) {
      const { name, slug, active } = initialValues;

      form.setFieldsValue({
        name,
        slug,
        active,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = (values) => {
    if (isEditing) {
      handleUpdate(values, initialValues.id);
    } else {
      handleCreate(values);
    }
  };

  const handleCreate = async (data) => {
    const hide = message.loading(REQUEST_LOADING);
    const isCreated = await ModulesService.createModule(data);

    if (isCreated) {
      hide();
      message.success(SUCCESS_CREATE);
      handleConfirm();
    }
  };

  const handleUpdate = async (data, id) => {
    const hide = message.loading(REQUEST_LOADING);
    const isUpdated = await ModulesService.editModule(data, id);

    if (isUpdated) {
      hide();
      message.success(SUCCESS_UPDATE);
      handleConfirm();
    }
  };

  const handleConfirm = () => {
    form.resetFields();
    onClose();
    onSuccess();
  };

  return (
    <Drawer
      title={isEditing ? 'Редактирование модуля' : 'Создание модуля'}
      width="50%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        initialValues={{ active: true }}
        labelAlign="right"
      >
        <Form.Item name="name" label="Наименование" rules={[requiredRule]}>
          <Input placeholder="Введите наименование" allowClear />
        </Form.Item>

        <Form.Item name="slug" label="Slug" rules={[requiredRule]}>
          <Input placeholder="Введите slug" allowClear />
        </Form.Item>

        <Form.Item name="active" label="Активный" valuePropName="checked">
          <Switch />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { ModulesForm };
